import {type AgentActionDef} from '../agentActions';
import {RUN_FILTER_ACTION} from './runFilterAction';

/**
 * The known UI actions. Add a new action's `AgentActionDef` here; each action
 * defines itself in its own module (e.g. `./runFilterAction`) — this just
 * aggregates them and keys them by tool name.
 */
const KNOWN_ACTIONS: AgentActionDef[] = [RUN_FILTER_ACTION];

export const AGENT_ACTIONS: Record<string, AgentActionDef> = Object.fromEntries(
  KNOWN_ACTIONS.map(action => [action.toolName, action])
);

export function isAgentAction(toolName: string): boolean {
  return Object.prototype.hasOwnProperty.call(AGENT_ACTIONS, toolName);
}
